import React from "react";
import { Doughnut } from "react-chartjs-2";
import { formatLabel } from "../../../utils/helper";

const B2BDonutChart = ({
  chartClassName,
  title,
  description,
  chartTitle,
  dataSource,
}) => {
  const labels = Object.keys(dataSource || {});
  const values = Object.values(dataSource || {});
  const totalValue =
    values.length > 0 ? values.reduce((acc, val) => acc + val, 0) : 0;
  const mostCommonLabel =
    values.length > 0 ? labels[values.indexOf(Math.max(...values))] : "N/A";

  const backgroundColors = [
    "#2FC9CD",
    "#F05289",
    "#8FD460",
    "#FFDB42CB",
    "#FFA500",
    "#00CED1",
  ];

  const dataD = {
    labels,
    datasets: [
      {
        label: "Overall Responses",
        data: values,
        backgroundColor: backgroundColors.slice(0, values.length),
        hoverBackgroundColor: backgroundColors.slice(0, values.length),
        borderWidth: 1,
        borderRadius: 10,
        borderColor: "#F2F2F2",
        borderJoinStyle: "round",
      },
    ],
  };

  const optionsD = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      color: {
        enabled: true,
      },
    },
    cutout: "90%",
    radius: "70%",
    // onResize: (chart) => {
    //   if (data.datasets[0].data.every(value => value === 0)) {
    //     chart.canvas.style.backgroundColor = '#f0f0f0'; // Set a default background color
    //   }
    // },
  };
  return (
    <div className="w-full p-6 border-[1.5px] border-shoorah-borderGray rounded-xl lg:rounded-2xl bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder text-shoorah-lightBlack dark:text-shoorah-darkBg">
      <div className="flex items-start justify-between">
        <div className="max-w-[272px]">
          <div className="text-lg sm:text-xl font-medium leading-9">
            {title}
          </div>
          <div className="leading-5">{description}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded-full bg-[#D9D9D9]"></div>
          <div className="w-6 h-6 rounded-full bg-[#D9D9D9]"></div>
        </div>
      </div>
      <div className="flex items-center justify-center relative">
        <div className="sm:w-[228px] w-[144px] h-[144px] sm:h-[228px] absolute border-[8px] sm:border-[12px] rounded-full border-[#F2F2F2]"></div>
        <div className="flex flex-col items-center gap-3 absolute">
          <div className="text-[15px] leading-[17px] text-[#606060] dark:text-shoorah-darkBg">
            {chartTitle}
          </div>
          <div className="text-[27px] leading-[29px] font-medium text-shoorah-lightBlack dark:text-white">
            {formatLabel(mostCommonLabel)}
          </div>
        </div>
        <Doughnut
          data={dataD}
          options={optionsD}
          style={{ width: "100%", height: "100%" }}
          className={`sm:!w-[326px] !w-[206px] !h-[206px] sm:!h-[326px] ${chartClassName} z-10`}
        />
      </div>
      <div className="flex sm:items-center flex-col sm:flex-row gap-10 sm:justify-between sm:px-5 md:px-5 m-auto">
        {/* <div className="space-y-5">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-[#F05289]"></div>
            <div className="text-base leading-5 text-[#606060] dark:text-shoorah-darkBg">
              Male:{' '}
              <span className="text-xl font-semibold leading-6 text-shoorah-lightBlack dark:text-white">
                1,135
              </span>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-[#F05289]"></div>
            <div className="text-base leading-5 text-[#606060] dark:text-shoorah-darkBg">
              Male:{' '}
              <span className="text-xl font-semibold leading-6 text-shoorah-lightBlack dark:text-white">
                1,135
              </span>
            </div>
          </div>
        </div> */}
        <div className="mt-6 mx-auto grid grid-cols-2 gap-y-5 gap-x-10">
          {labels.map((label, index) => (
            <div key={label} className="flex items-center gap-2">
              <div
                className="w-2 h-2 rounded-full"
                style={{
                  backgroundColor:
                    backgroundColors[index % backgroundColors.length],
                }}
              ></div>
              <div className="text-base leading-5 text-[#606060] dark:text-shoorah-darkBg">
                {formatLabel(label)}:{" "}
                <span className="text-lg font-semibold leading-6 text-shoorah-lightBlack dark:text-white">
                  {values[index]}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default B2BDonutChart;
